import { StrictMode } from 'react'
import { i18nReady } from './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

i18nReady.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
